export default __webpack_public_path__ + "static/media/Edit.5601a0a6.svg";